import React, { useState, useEffect } from "react";

// Style //
import "./OverView.css";

// Components //
import { PieChart, PageHeading, Loader } from "../../common/components/index";

// Images //
import { icons } from "../../assets/index";
import { useDispatch, useSelector } from "react-redux";

// Actions //
import {
  requestSent,
  responseRecived,
  receivedError,
} from "../../redux/actions/utilsActions";

// API's //
import {
  soleTraderChartDataApi,
} from "../../api/overview";
import { getTicketsStats } from "../../api/commonApis";
import { soleTraderColorsEnum } from "../../utils/constants";

const OverView = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.utils);
  const { user, userToken } = useSelector((state) => state.user);
  const [subContractorcount, setSubContractorCount] = useState([]);
  const [subContractorStatus, setSubContractorStatus] = useState([]);
  const [subContractorsTotal, setSubContractorsTotal] = useState(0);
  const [subContractorColorPalette, setSubContractorColorPalette] = useState([]);
  const [ticketsStats, setTicketsStats] = useState([0, 0]);

  // API Calls //
  const overViewPageApis = async () => {
    try {
      dispatch(requestSent());
      const [
        {
          count: subContractorCount,
          status: subContractorStatus,
          total: subContractorsTotal,
        },
        {
          expired_tickets_count,
          expiring_tickets_count
        }
      ] = await Promise.all([
        soleTraderChartDataApi(userToken),
        getTicketsStats(userToken),
      ]);

      setTicketsStats([expiring_tickets_count, expired_tickets_count])

      setSubContractorCount(subContractorCount);
      const statuses = subContractorStatus.map(e => {
        if (e === 'MISSINGDOCS') {
          return 'Pending Induction'
        } else if (e === 'PENDING_RIGHT_TO_WORK') {
          return 'Pending RIGHT TO WORK'
        } else {
          return e
        }
      })
      setSubContractorStatus(statuses);
      setSubContractorColorPalette(rearrangeColorPalette(statuses))
      setSubContractorsTotal(subContractorsTotal);

      dispatch(responseRecived());
    } catch (err) {
      console.log("OverView error::", err);
      dispatch(receivedError(err));
    }
  };

  const rearrangeColorPalette = (statuses) => {
    const colorMapping = {
      "ACTIVE": soleTraderColorsEnum['ACTIVE'],
      "INACTIVE": soleTraderColorsEnum['INACTIVE'],
      "Pending Induction": soleTraderColorsEnum['MISSINGDOCS'],
      "Pending RIGHT TO WORK": soleTraderColorsEnum['PENDING_RIGHT_TO_WORK'],
    };

    // Create a new array to hold the rearranged colors
    let rearrangedColors = new Array(statuses.length);

    // Iterate through the statuses array and place the corresponding color in the correct position
    for (let i = 0; i < statuses.length; i++) {
      rearrangedColors[i] = colorMapping[statuses[i]];
    }

    return rearrangedColors;
  }

  // useEffect //
  useEffect(() => {
    window.scrollTo(0, 0);
    if (userToken) {
      overViewPageApis();
    }
  }, [userToken]);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <PageHeading
        title={`Welcome back ${user?.contractorData?.Company?.name.charAt(0).toUpperCase() +
          user?.contractorData.Company.name.slice(1)
          }`}
      />
      <div className="overview_cont">

        <div className="cont">
          <h3>Sub-Contractors</h3>
          {subContractorsTotal ? (
            <PieChart
              series={subContractorcount}
              chartLable={"Sub-contractors"}
              toolTipLabels={subContractorStatus}
              totalValue={subContractorsTotal}
              indicatorColors={subContractorColorPalette}
            />
          ) : (
            <div className="pending_time_sheet_empty">
              <div className="place_holder_img_cont">
                <img src={icons.subContractor} alt="" />
              </div>
              <h2>There Are No Sub-Contractors</h2>
            </div>
          )}
        </div>

        <div className="cont">
          <h3>Training Tickets Overview</h3>

          <div className="pending_time_sheet_empty">

            <div className="expiring_tickets_row">
              <h2>Numbers of training tickets expiring (In the next 6 months)</h2>
              <h1>{ticketsStats[0]}</h1>
            </div>
            <div className="expiring_tickets_row mt-1">
              <h2>Numbers of training tickets expired</h2>
              <h1>{ticketsStats[1]}</h1>
            </div>

          </div>
        </div>

        <div className="cont">
          <h3>How-To Guides</h3>
          <div className="pending_time_sheet_empty d-flex">
            <h2> <a href="https://www.youtube.com/playlist?list=PLXSbnqMrcGbrdBkgAkHG20G5UToPHIH0o" target="_blank">How to use your client portal</a></h2>
            <h2> <a href="https://www.youtube.com/playlist?list=PLXSbnqMrcGbqrJy1kdPtrJb-hT-vDEjMA" target="_blank">How to use the subcontractor app</a></h2>
          </div>
        </div>

      </div>
    </>
  );
};

export default OverView;
